import React from "react";
import { Snackbar, Alert, styled, Box, Typography } from "@mui/material";
import {
  CheckCircle as SuccessIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  padding: "12px 16px",
  "& .MuiAlert-icon": {
    padding: 0,
    opacity: 1,
    fontSize: 24,
  },
  "& .MuiAlert-message": {
    padding: 0,
    minWidth: 240,
  },
  "& .MuiAlert-action": {
    padding: 0,
    marginRight: -8,
  },
}));

const MessageContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const icons = {
  success: <SuccessIcon fontSize="inherit" />,
  error: <ErrorIcon fontSize="inherit" />,
  info: <InfoIcon fontSize="inherit" />,
  warning: <WarningIcon fontSize="inherit" />,
};

const SnackbarMessage = ({
  open,
  onClose,
  message,
  severity = "success",
  autoHideDuration = 3000,
  title,
  position = {
    vertical: "bottom",
    horizontal: "center",
  },
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={position}
      sx={{
        "& .MuiSnackbar-root": {
          minWidth: 300,
        },
      }}
    >
      <StyledAlert
        onClose={onClose}
        severity={severity}
        variant="filled"
        icon={icons[severity]}
        elevation={6}
      >
        <MessageContent>
          {title && (
            <Typography variant="subtitle2" fontWeight="600">
              {title}
            </Typography>
          )}
          <Typography variant="body2">{message}</Typography>
        </MessageContent>
      </StyledAlert>
    </Snackbar>
  );
};

export default SnackbarMessage;
